
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/state-requirements",
      function () {
        return require("private-next-pages/reports/state-requirements/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/state-requirements"])
      });
    }
  